import { DirectCallRules } from './direct-call-rules'

export { DirectCallRules }

export default function (eventName: DirectCallRules): void {
  if (window && window._satellite && typeof window._satellite.track === 'function') {
    window._satellite.track(eventName)
  }
}
